import apiConfig from "../../config/apiConfig";
import { objToQueryString, showSuccessToasts } from "../../services/helpers/Helper";
import { END_POINT, MESSAGE_SETTING_GENERAL_TYPE } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const fetchMessageSettingGeneral = () =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.PAGE_GREETINGS}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: MESSAGE_SETTING_GENERAL_TYPE.FETCH,
            payload: response.data
         })
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });

   };

export const onChangeText = (string) =>
   async (dispatch) => {
      dispatch({
         type: MESSAGE_SETTING_GENERAL_TYPE.ON_CHANGE_TEXT,
         payload: string
      })
   }

export const onUpdate = (string) =>
   async (dispatch, getState) => {
      const { page, messageSettingGeneral } = getState();
      const params = {
         fb_page_id: page.social_id,
         content: messageSettingGeneral.text,
         is_actived: messageSettingGeneral.is_actived
      }
      const endPoint = END_POINT.GREETINGS;
      dispatch(showLoading());
      apiConfig.post(endPoint, params).then((response) => {
         dispatch({
            type: MESSAGE_SETTING_GENERAL_TYPE.FETCH,
            payload: response.data
         });
         showSuccessToasts("Cập nhật thành công");
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
      dispatch({
         type: MESSAGE_SETTING_GENERAL_TYPE.UPDATE,
         payload: string
      })
   }

export const onChangeActive = (number) =>
   async (dispatch) => {
      dispatch({
         type: MESSAGE_SETTING_GENERAL_TYPE.ON_CHANGE_ACTIVE,
         payload: number
      });
      dispatch(onUpdate())
   }